import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const CrossIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 8),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    children: /*#__PURE__*/jsx("path", {
      d: "m1 7 6-6M7 7 1 1"
    })
  });
};

export { CrossIcon };
//# sourceMappingURL=cross.js.map
